import { render, staticRenderFns } from "./TraxTrainingGroupRegistrationCrudSearch.vue?vue&type=template&id=eb7dbfcc"
import script from "./TraxTrainingGroupRegistrationCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxTrainingGroupRegistrationCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports